<template>
  <div>
    <div ref="defectsMonitoringChart"></div>
  </div>
</template>

<script>
import ReportService from "@/services/ReportService"
import ApexCharts from "apexcharts"
export default {
  name: "Overview",
  props: ["id", "filter"],
  data() {
    return {
      defects: {},
      series: [],
      chartOptions: {},
      chart: null
    }
  },
  mounted() {
    this.getDefectsMonitoring()
  },
  watch: {
    filter(newValue) {
      this.getDefectsMonitoring(true)
    }
  },
  methods: {
    getDefectsMonitoring(update) {
      this.$emit("defectsMonitoringLoading", true)
      ReportService.getDefectsMonitoring(this, this.id, this.filter)
        .then(r => {
          this.series = []
          this.defects = {}
          r.map(defect => {
            if (this.defects[defect.reason] === undefined) {
              this.defects[defect.reason] = []
            }
            this.defects[defect.reason].push([new Date(defect.day).getTime(), defect.count])
          })
          for (const [key, value] of Object.entries(this.defects)) {
            this.series.push({ name: key, data: value })
          }
          this.chartOptions = {
            noData: { text: "No defects found." },
            colors: ["#481c74", "#Ff444c", "#94c41c", "#00B0FF", "#FFC565", "#9F88B1", "#6F0400"],
            series: [],
            chart: {
              type: "line",
              height: "500"
            },
            markers: {
              size: 6,
              strokeWidth: 1,
              shape: "circle"
            },
            legend: {
              show: true,
              position: "right",
              horizontalAlign: "bottom"
            },
            xaxis: {
              type: "datetime"
            },
            yaxis: {
              min: -0.1
            }
          }
          this.chartOptions = {
            ...this.chartOptions,
            ...{
              series: this.series
            }
          }
          if (!update) {
            this.chart = new ApexCharts(this.$refs.defectsMonitoringChart, this.chartOptions)
            this.chart.render()
          } else {
            this.chart.updateOptions(this.chartOptions)
          }
        })
        .finally(() => {
          this.$emit("defectsMonitoringLoading", false)
        })
    }
  }
}
</script>
